
import {UIState} from "data/UIState";
import * as React from "react";

import './HRFooter.pcss';

export const HRFooter = (props:{}) =>
    <div className="hr-footer">
      <p>
        Access provided for {UIState.settings.COMPANY_NAME}.
        <br />
        Need help? Email <a href={"mailto:strive@well-concepts.com?subject=Strive%20HR%20Tool%20Help"}>strive@well-concepts.com</a>
      </p>
    </div>
;